// 定义人工审核类型枚举
export enum ManualReviewType {
  IDCARD = 'idcard',      // 身份证认证
  LICENSE = 'license',     // 资质认证
  PHONE = 'phone',        // 手机号认证
}

// 枚举类型的元数据
export interface ManualReviewTypeMetadata {
  title: string;
  subtitle: string;
  type: ManualReviewType;
}

// 枚举值对应的元数据映射
export const manualReviewTypeMetadata: Record<ManualReviewType, ManualReviewTypeMetadata> = {
  [ManualReviewType.IDCARD]: {
    title: '身份证认证',
    subtitle: '基本实名认证',
    type: ManualReviewType.IDCARD,
  },
  [ManualReviewType.LICENSE]: {
    title: '资质认证',
    subtitle: '道路运输许可证认证',
    type: ManualReviewType.LICENSE,
  },
  [ManualReviewType.PHONE]: {
    title: '手机号认证',
    subtitle: '手机号实名核验',
    type: ManualReviewType.PHONE,
  },
};
